/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const SenderMobileColumnFormatter = (cellContent, row, rowIndex) => {
  const { senderMobile } = row;

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {senderMobile ? senderMobile : `-`}
      </div>
      <> </>
    </>
  );
};
